export default {
  deep: "DEEP",
  search: "Buscar...",
  roles: {
    admin: "Administrador",
    controlCenter: "Centro de Control",
  },
};
